import { Box, Container } from '@chakra-ui/react';

type Props = {
  content: React.ReactNode;
  sticky?: boolean;
};

export const NotificationBanner: React.FC<Props> = ({ content, sticky }) => (
  <Container
    data-testid="notification-banner"
    border="1px"
    borderColor="neutral.light"
    backgroundColor="brand.lightest"
    justifyContent="space-between"
    textAlign="center"
    padding="m"
    {...(sticky && { overflow: 'visible', position: 'sticky', top: 0 })}
  >
    <Box flex="1">{content}</Box>
  </Container>
);
